export interface ThingEventPageResponse<TItem> {
  count: number;
  hasMore: boolean;
  items: TItem[];
}

type ThingEventFetcher = (entityId: string, params: Record<string, unknown>) => Promise<unknown>;

export const TRIP_HISTORY_EVENT_PAGE_LIMIT = 1000;

export const fetchAllThingEvents = async <TItem>(
  fetchThingEvents: ThingEventFetcher,
  entityId: string,
  params: Record<string, unknown>,
): Promise<ThingEventPageResponse<TItem>> => {
  const baseParams: Record<string, unknown> = { ...params };
  delete baseParams.limit;
  delete baseParams.skip;

  const allItems: TItem[] = [];
  let resolvedCount: number | undefined;

  const fetchPage = async (skip: number): Promise<void> => {
    const rawResponse = await fetchThingEvents(entityId, {
      ...baseParams,
      limit: TRIP_HISTORY_EVENT_PAGE_LIMIT,
      skip,
    });

    const response = (rawResponse as {
      count?: number;
      hasMore?: boolean;
      items?: TItem[];
    } | undefined) ?? {};

    const pageItems = Array.isArray(response.items) ? response.items : [];
    allItems.push(...pageItems);

    if (Number.isFinite(response.count)) {
      resolvedCount = response.count;
    }

    if (!response.hasMore || pageItems.length === 0) {
      return;
    }

    await fetchPage(skip + pageItems.length);
  };

  await fetchPage(0);

  return {
    count: resolvedCount ?? allItems.length,
    hasMore: false,
    items: allItems,
  };
};
